export default {
    state: () => ({
        isModalVisible: false,
    }),
    getters: {
        getModalState(state) {
            return state.isModalVisible
        }
    },
    mutations: {
        setIsModalVisible(state, isModalVisible) {
            state.isModalVisible = isModalVisible;
        },
    },
    actions: {
        toggleIsModalVisible({state, commit}) {
            if (state.isModalVisible) {
                document.body.classList.remove('body-scroll-hidden');
            } else {
                document.body.classList.add('body-scroll-hidden');
            }
            commit('setIsModalVisible', !state.isModalVisible);
        },
    },
    namespaced: true,
};
